<template>
  <div class="userInfo">
    <div class="left">
      <div class="leftcontent">
        <div class="whl-head-box cursor" @click="changePhoto">
          <div>
            <img :src="user_photo" alt ondragstart="return false;" />
            <p>更换头像</p>
          </div>
          <img :src="userHeadwear" alt="更换头像" v-if="userHeadwear" />
        </div>
        <div class="name info">{{ realname | realSubstring }}</div>
        <div class="phone info">{{ phone }}</div>
        <div class="my-prise-box">
          <!-- <div class="coin cursor" @click="openCoinWebView"> -->
          <div class="coin cursor">
            <img
              src="../../../assets/img/common/coin.png"
              alt
              ondragstart="return false;"
            />
            <i class="num">{{ coinAllnum }}</i>
          </div>
          <!-- <div class="badge cursor" @click="goMyBadge">
            <img
              src="../../../assets/img/common/badge.png"
              alt
              ondragstart="return false;"
            />
            <i class="num">{{ userBadgeNum }}</i>
          </div> -->
        </div>
        <div class="logout">
          <span class="exit1 cursor" @click.stop="logOut">退出</span>
        </div>
      </div>
    </div>
    <div class="right">
      <ul>
        <li @click="goPages('equipment', 1)">
          <span>设备检测</span>
        </li>
        <li @click="goPages('advice', 2)">
          <span>问题反馈</span>
        </li>
        <!-- <li v-if="LIMI_ENV" @click="goPages('update',3)">
          <span>版本更新</span>
          <span class="version-hint">{{newVersion?'新版本':'已是最新版本'}}</span>
        </li>
        <li @click="goPages('explain',4)">
          <span>隐私政策</span>
        </li>
        <li @click="goChildPages">
          <span>儿童隐私保护</span>
        </li>
        <li @click="goPages('forrecord',5)">
          <span>备案公示</span>
        </li>
        <li @click="goPages('cancell',6)">
          <span>注销账号</span>
        </li> -->
      </ul>
    </div>

    <div class="versions" v-if="LIMI_ENV">版本号V{{ version }}</div>
    <!-- 同班同学组件 -->
    <Back @goBack="goClassList" />
    <!-- 退出提示 -->
    <Alert
      :show="showAlertFlag"
      :sameOne="des"
      :btn="'确定'"
      :cancal="'取消'"
      @cancelEvent="showAlertFlag = false"
      @ensure="gologin"
    />
  </div>
</template>

<script>
import Back from "@/components/basic/back.vue";
import Alert from "@/components/basic/alert.vue";
import utils from "utils";
import { mapState, mapMutations, mapActions } from "vuex";
import common from "common";
export default {
  name: "userInfo",
  data() {
    return {
      des: "确认退出当前账号吗？",
      showAlertFlag: false, //点击退出时的提示,
      version: common.version,
      saveSetings: [
        "selfGradeIndex",
        "selfLessonIndex",
        "selfSubjectIndex",
        "semesterIndex",
        "classYearIndex",
      ],
      LIMI_ENV: LIMI_ENV === "electron",
    };
  },
  components: {
    Back,
    Alert,
  },
  mounted() {
    this.modifyPhotoFn();
    this._updateHeadwear();
    if (this.LIMI_ENV) {
      this.$root.eventHub.$emit("updateVersion", 1);
    }
  },
  computed: {
    ...mapState([
      "phone",
      "realname",
      "coinAllnum",
      "userBadgeNum",
      "user_photo",
      "newVersion",
      "userHeadwear",
    ]),
  },
  methods: {
    ...mapMutations(["resetState", "refreshNet"]),
    ...mapActions(["modifyPhoto", "updateHeadwear"]),
    goChildPages() {
      this.$router.push("ChildrenPolicy");
    },
    goPages(pageName, mode) {
      let id = "";
      let data = {};
      switch (mode) {
        case 1:
          id = "LMTrackEventEquminetClick";
          break;
        case 2:
          id = "LMTrackEventFeedBack";
          data.page = 2;
          break;
        case 3:
          id = "LMTrackEventUpdateInMy";
          break;
        case 4:
          id = "LMTrackEventPrivacyClick";
          break;
        case 5:
          id = "LMTrackEventUserInfoRecordPublicit";
          break;
        case 6:
          id = "LMTrackEventContactUs";
          break;
      }
      this.$root.eventHub.$emit("createLog", {
        id,
        data,
      });
      this.$router.push(pageName);
    },
    openCoinWebView() {
      //this.$root.eventHub.$emit("goCoinWebView",true);
      this.$router.push({ name: "coinrecord" });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventCoinClick",
        data: { page: 2 },
      });
    },
    //点击更换头像
    changePhoto() {
      this.$router.replace({
        name: "changePhoto",
      });
    },
    //退出到登录页面
    logOut() {
      this.showAlertFlag = true;
    },
    gologin() {
      this.$root.eventHub.$emit("createLog", { id: "LMTrackEventLogout" });
      //window.sessionStorage.clear()
      this.showAlertFlag = false;
      this.resetState();
      this.clearTool();
      this.$router.replace({
        path: "/login",
        query: {
          from: "userInfo",
        },
      });
    },
    clearTool() {
      for (let i of this.saveSetings) {
        localStorage.removeItem(i);
      }
    },
    //返回到班级列表页面
    goClassList() {
      this.$router.replace("/class");
    },
    //修改头像
    modifyPhotoFn() {
      if (!!!this.$route.query.photoId) return;
      let id = this.$route.query.photoId;
      this.modifyPhoto({
        image_name: id,
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventSwitchIcon",
        data: {
          id,
        },
      });
    },
    // 修改头饰
    _updateHeadwear() {
      if (this.$route.query.headwearId == undefined) return;
      let id = this.$route.query.headwearId;
      this.updateHeadwear({
        headwearId: id,
      });
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventSwitchHeadwear",
        data: {
          id,
        },
      });
    },
    //点击返回我的徽章页面
    goMyBadge() {
      this.$router.replace({
        path: "/myselfBadge",
        query: {
          flag: "userInfo",
        },
      });
    },
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less" scoped>
.userInfo {
  background: #425bc2;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  .left {
    width: 37%;
    height: 100%;
    position: relative;
    background: #3940a2;
    background-size: 178px 128px;
    .leftcontent {
      float: right;
      padding-right: 60px;
      height: 100%;
      min-width: 320px;
      min-height: 530px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;
      .whl-head-box {
        width: 233px;
        height: 233px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
        & > div:first-child {
          height: 140px;
          width: 140px;
          border-radius: 50%;
          overflow: hidden;
          position: relative;
          display: flex;
          justify-content: center;
          background: #02708f;
          border: 5px solid #fff;
          & > img {
            height: 140px;
            width: 140px;
            border-radius: 50%;
          }
          & > p {
            background: rgba(0, 128, 201, 0.5);
            display: flex;
            justify-content: center;
            width: 145px;
            height: 40px;
            padding-top: 5px;
            position: absolute;
            z-index: 3;
            top: 90px;
            pointer-events: none;
            font-size: 17px;
            color: #fff;
          }
        }
        & > img:nth-child(2) {
          width: 233px;
          height: 233px;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 5;
        }
      }
      .info {
        color: #d7ecf2;
        width: 100%;
        margin-bottom: 8px;
      }
      .name {
        margin-top: -32px;
        font-size: 23px;
      }
      .phone {
        font-size: 16px;
        margin-top: -5px;
      }
      .my-prise-box {
        height: 50px;
        width: 100%;
        margin-top: 34px;
        font-size: 0;
        img {
          width: 50px;
          height: 50px;
          margin-top: -25px;
          display: inline-block;
        }
        .num {
          font-size: 34px;
          color: #ffffff;
          padding: 0 22px 0 12px;
          line-height: 49px;
          font-family: Roboto_Regular;
        }
        .coin,
        .badge {
          background: #32368a;
          border-radius: 40px;
          display: inline-block;
          position: relative;
          font-size: 0;
        }
        .coin {
          left: -20px;
        }
        .badge {
          right: -19px;
          position: relative;
          padding-left: 50px;
          img {
            position: absolute;
            left: -6px;
            top: 23px;
          }
        }
      }
      .logout {
        width: 320px;
        margin-top: 100px;
        .exit1 {
          text-align: center;
          border-radius: 54px;
          height: 54px;
          width: 100%;
          font-size: 23px;
          line-height: 54px;
          color: rgba(57, 64, 162, 1);
          background: #fff;
          display: inline-block;
          &:hover {
            background: #ffffff;
            color: rgba(57, 64, 162, 0.7);
          }
        }
      }
    }
  }
  .right {
    font-size: 21px;
    color: #fff;
    display: flex;
    align-items: center;

    li {
      width: 710px;
      cursor: pointer;
      height: 100px;
      text-align: left;
      background: url("../../../assets/img/common/arrow_right.png") no-repeat;
      height: 96px;
      line-height: 96px;
      background-size: 8px;
      background-position: 630px center;
      padding-left: 125px;
      padding-right: 36px;
      &:hover {
        background-color: #3940a2;
      }
      .version-hint {
        color: #8acbed;
        font-size: 16px;
        float: right;
        padding-right: 55px;
      }
    }
  }
}
.versions {
  position: fixed;
  font-size: 19px;
  color: #4096ae;
  bottom: 40px;
  right: 30px;
  z-index: 4;
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/userInfo/userInfo.vue